module.exports = {"data":{"markdownRemark":{"html":"<p>WIP: This page will describe the new Remote Control feature (and its limitations).</p>","frontmatter":{"path":"/SF2RemoteControl","title":"SubFire 2 Remote Control Features","summary":"The Mobile-Friendly Subsonic Client"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sf-2-remote-control.json
// module id = 390
// module chunks = 123551693136459